var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9318 16.2206L31.5984 32.3545C31.3578 33.4893 30.7048 33.7729 29.777 33.2411L24.7252 29.4469L22.2852 31.8582C22.0103 32.1418 21.8042 32.3545 21.2543 32.3545L21.6324 27.0357L31.0141 18.3127C31.4265 17.9227 30.9111 17.7454 30.3955 18.1L18.7799 25.6173L13.7969 24.0217C12.6972 23.667 12.6972 22.8869 14.0375 22.3551L33.5228 14.5895C34.4507 14.2704 35.2411 14.8023 34.9318 16.2206Z",
    fill: "#A0EE09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconTelegram);
export default __webpack_public_path__ + "static/media/menu-icon-telegram.c825f821e538d742a66fcf758dd99455.svg";
export { ForwardRef as ReactComponent };